export default "__VITE_ASSET__3dd66716__"